import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const MarkFeatureSlice = createSlice({
    name: "markFeature",
    initialState,
    reducers: {
        markFeatureRequest(state) {
            state.loading = true;
        },
        markFeatureRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        markFeatureRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        markFeatureStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    markFeatureRequest,
    markFeatureRequestSuccess,
    markFeatureRequestError,
    markFeatureStateReset,
} = MarkFeatureSlice.actions;

export default MarkFeatureSlice.reducer;
